import SearchFilter from "./SearchFilter";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { HStack, Wrap } from "../../../../styled-system/jsx";
import { ButtonGroup } from "../../core/basic/ButtonGroup";
import { css } from "../../../../styled-system/css";

const FilterBar = ({
  selectedSearchId,
  shelfData,
  selectedShelf,
  filterSearchId,
  selectedRollupType,
  filterRollupType,
  dateRange: [start, end],
  setSelectedDateRange,
  isLoading,
}) => {
  const { t } = useTranslation(["merchandising"]);
  return (
    <>
      <Wrap justify={"space-between"}>
        <ButtonGroup
          buttons={[
            {
              value: "page_1",
              label: t(($) => $.merchandising["Page 1"]),
            },
            {
              value: "above_fold",
              label: t(($) => $.merchandising["Above Fold"]),
            },
          ]}
          value={selectedRollupType}
          onSelect={filterRollupType}
        />

        <HStack gap="medium">
          <DatePicker
            placeholderText={t(($) => $.merchandising["Start"])}
            onChange={(d) => {
              setSelectedDateRange([moment(d), end]);
            }}
            selected={start.toDate()}
          />
          <span className={css({ fontSize: "medium", fontWeight: "bolder" })}>{t(($) => $.merchandising["to"])}</span>
          <DatePicker
            placeholderText={t(($) => $.merchandising["End"])}
            onChange={(d) => {
              setSelectedDateRange([start, moment(d)]);
            }}
            selected={end.toDate()}
          />
        </HStack>

        <SearchFilter
          shelfData={shelfData}
          filterSearchId={filterSearchId}
          selectedShelf={selectedShelf}
          selectedSearchId={selectedSearchId}
        />
      </Wrap>
      <div>
        {isLoading && (
          <>
            <i className="fa fa-spin fa-circle-o-notch" /> {t(($) => $.merchandising["Loading"])}
          </>
        )}
      </div>
    </>
  );
};

export default FilterBar;
